<style lang="scss" src='./CourseUsers.scss' scoped></style>
<template src="./CourseUsers.html"></template>

<script>
  import { saveGolfCourse, uploadGolfImages, uploadUserPhotoV2 } from '@/api/index';

  import CourseUserList from '@/views/course/setup/users/userList/CourseUserList.vue';
  import CourseNewUser from '@/views/course/setup/users/newUser/CourseNewUser.vue';
  
  import { mapState, mapMutations, mapActions } from 'vuex';
  import { omit } from 'lodash';

  export default {
    name: 'CourseUsers',
    components: {
      CourseUserList,
      CourseNewUser,
    },

    data() {
      return {
      };
    },

    computed: {
      ...mapState('CourseSetup', {
        showNewUserPage: (state) => state.showNewUserPage,
        setupData: (state) => state.setupData,
        backgroundImgs: (state) => state.backgroundImgs,
        logo: (state) => state.logo,
      }),
    },

    methods: {
      
      async continue() {
        // this.setLoading({btnContinue: true});

        // const usersWithPhotos = this.setupData.users.filter(u => u.photo && u.photo.url);
        // const golfCourseData = {...this.setupData, 
        //                         users: this.setupData.users.map(u => (
        //                           // For existing users we only send user_id
        //                           u.user_id ? { user_id: u.user_id } : omit(u, ['photo']) 
        //                         )),
        //                         sensors: this.setupData.sensors}
        
        // saveGolfCourse(golfCourseData).then(async (response) => {
        //   /** Upload course images, logo and backgrounds */
        //   const usersSaved = response.users;
        //   await this.updaloadUserPhotos(usersWithPhotos, usersSaved);
        //   let responseImgs = await this.uploadCourseImages(response.course.course_id);
        //   if (responseImgs && responseImgs.data && responseImgs.data.data && responseImgs.data.data.course_id) {
        //     response.course = responseImgs.data.data;
        //   }
        //   this.addCourse(response.course);
        //   this.addUserCourse(response.course);

        //   if (process.env.VUE_APP_SENTRY_ENV == "production") {
        //     this.$analytics.logEvent("web_golf_courses_finish");
        //   }
        //   this.$router.push('/courses');
        // }).finally(() => {
        //   this.setLoading({btnContinue: false});
        // });

        return true;
      },

      async updaloadUserPhotos(usersWithPhotos, usersSaved) {
        if (!this.G_isEmptyArr(usersWithPhotos) && !this.G_isEmptyArr(usersSaved)) {
            /** Upload user photos */
            usersWithPhotos.forEach(async (userPhoto) => {
              const user = usersSaved.find(u => u.username == userPhoto.username);

              await uploadUserPhotoV2(user.user_id, userPhoto.photo)
            });
        }
      },

      ...mapActions('CourseSetup', ['uploadCourseImages']),
      ...mapMutations('CourseSetup', ['setCanContinue', 'setCanBack', 'setLoading']),
      ...mapMutations('Courses', ['addCourse']),
      ...mapMutations(['addUserCourse']),
    },

    activated() {
      this.setLoading({btnContinue: false});
      this.setCanContinue(this.continue);
      this.setCanBack(null);
    },

    mounted() {
      if (process.env.VUE_APP_SENTRY_ENV == "production") {
        this.$analytics.setCurrentScreen("Web Golf Courses Users");
        this.$analytics.logEvent("web_golf_courses_users");
      }
    },

    beforeDestroy() {
    },
  };

</script>
